import { CircularProgress, Paper, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { useState, useEffect } from 'react';
import FleetWebApi from "../Api/FleetWebApi";

import IUser from "../models/Users/IUser";

import UserRole from "./UserRoleView";
import EditUserField from "./EditUserField";
import { UserRoles } from "../AuthDataProvider";

type UserProps = {
    userId: string;
};

export const User = (props: UserProps) => {
    const [error, setError] = useState<string | null>(null);
    const [user, setUser] = useState<IUser | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        FleetWebApi.getUser(props.userId)
            .then(response => {
                setUser(response);
                setIsLoading(false);
            })
            .catch(error => {
                setError(error.message);
                setIsLoading(false);
            });
    }, [props.userId]);

    return (
        <Paper className="paper">
            {user ?
                <Table classes={{ root: "reactivetable" }}>
                    <TableBody>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>{user._id}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>{user.name}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>E-Mail</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Roles</TableCell>
                            <TableCell>{user?.roles.map((userRole, i) => (
                                <UserRole key={i} role={userRole} />
                            ))}</TableCell>
                            <TableCell><EditUserField
                                userId={user._id}
                                fieldKey="roles"
                                fieldValue={user.roles.toString()}
                                friendlyField="User Roles"
                                details="'admin', 'art', 'dataScience', 'reviewer'"
                                fieldType="list"
                                updateUser={(data: UserRoles[]) => setUser(prevState => (prevState ? { ...prevState, roles: data } : null))}
                            /></TableCell>
                        </TableRow>

                    </TableBody>
                </Table>
                : null}
            {isLoading && <CircularProgress color="secondary" />}
            {error}

        </Paper>
    )
}